import { Routes } from '@angular/router';
import { LoginComponent } from './Common/login/login.component';
import { HomeComponent } from './Dashboard/home/home.component';
import { AuthGuard } from './auth.guard';
import { from } from 'rxjs';
import { SetRingtoneComponent } from './Dashboard/set-ringtone/set-ringtone.component';
import { BulkUploadComponent } from './Dashboard/bulk-upload/bulk-upload.component';
import { ReportTableComponent } from './Dashboard/report-table/report-table.component';

export const routes: Routes = [
    {path:'', pathMatch:'full', redirectTo:'login'},
    {path:'login', component:LoginComponent},
    // {path:'dashboard', component:HomeComponent, canActivate: [AuthGuard]}
    {path:'home', component:HomeComponent, canActivate: [AuthGuard]},
    { path: 'bulk-upload', component: BulkUploadComponent, canActivate: [AuthGuard] },
    { path: 'report-table', component: ReportTableComponent, canActivate: [AuthGuard] },
    {path:'set-ringtone', component:SetRingtoneComponent, canActivate: [AuthGuard]}
];
